import { render } from "./AccessConnections.vue?vue&type=template&id=87bf1a2a&scoped=true"
import script from "./AccessConnections.vue?vue&type=script&lang=js"
export * from "./AccessConnections.vue?vue&type=script&lang=js"

import "./AccessConnections.vue?vue&type=style&index=0&id=87bf1a2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bf1a2a"]])

export default __exports__